/**
 * SplashIntroPage — 랜딩페이지 "소개" 탭
 *
 * 2026-07-31 시안(Figma PT8wG7aRcWg4CerPViHOI4 · 2828:1753)으로 전면 교체.
 * 이 파일은 섹션 조립 + 푸터만 담당하고, 각 섹션은 splash/ 하위에 있다.
 *
 * 푸터는 시안(2828:2253)을 적용하지 않고 기존 내용을 그대로 유지한다 —
 * 사업자 정보·법적고지가 들어 있어 별도 차수로 다룬다.
 *
 * 색: 섹션들은 landing.css의 --lp-* 변수를 쓴다(D-07 §1.2 랜딩페이지 예외).
 *     푸터는 기존대로 표준 토큰을 유지한다.
 */
import { useNavigate } from 'react-router';
import { HeroSection } from './splash/HeroSection';
import { StudioSection } from './splash/StudioSection';
import { FeatureSection } from './splash/FeatureSection';
import { CtaSection } from './splash/CtaSection';
import { FEATURES } from './splash/features';

export function SplashIntroPage() {
  const navigate = useNavigate();
  const goStart = () => void navigate('/login');

  const scrollToAgents = () => {
    document.getElementById('agents')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="flex flex-1 flex-col">
      <HeroSection onStart={goStart} onBrowseAgents={scrollToAgents} />

      <StudioSection />

      {FEATURES.map((feature) => (
        <FeatureSection key={feature.id} feature={feature} onStart={goStart} />
      ))}

      <CtaSection onStart={goStart} />

      {/* ── 푸터 — 내용은 기존 유지, 면만 어둡게(gray-700) ──────────────────
          어두운 면 위라 텍스트를 흰색 3단(흰색 / alpha-white-700 / -600)으로 뒤집는다.
          대비는 각각 10.3:1 · 6.0:1 · 4.9:1 로 WCAG AA 를 넘긴다(§19 는 예외 대상이 아니다). */}
      <footer className="bg-[var(--lp-footer-surface)] px-8 py-12">
        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-8 sm:grid-cols-3">
          <div>
            <div className="text-base font-bold text-[var(--lp-footer-text)]">
              인디피아<span className="text-[var(--lp-footer-text-muted)]">.</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-[var(--lp-footer-text-muted)]">
              인테리어 사장님의 AI 업무 파트너.
              <br />
              현장을 더 스마트하게, 비즈니스를 더 강하게.
            </p>
          </div>
          <div>
            <p className="mb-2 text-xs font-semibold text-[var(--lp-footer-text)]">고객지원</p>
            <a
              href="/cs/inquiry"
              className="text-xs text-[var(--lp-footer-text-muted)] hover:text-[var(--lp-footer-text)] hover:underline"
            >
              파트너 문의
            </a>
          </div>
          <div>
            <p className="mb-2 text-xs font-semibold text-[var(--lp-footer-text)]">법적고지</p>
            <div className="flex flex-col gap-1.5">
              <a
                href="/terms"
                className="text-xs text-[var(--lp-footer-text-muted)] hover:text-[var(--lp-footer-text)] hover:underline"
              >
                이용약관
              </a>
              <a
                href="/privacy"
                className="text-xs text-[var(--lp-footer-text-muted)] hover:text-[var(--lp-footer-text)] hover:underline"
              >
                개인정보처리방침
              </a>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-4xl border-t border-[var(--lp-footer-border)] pt-6 text-center">
          <p className="text-xs text-[var(--lp-footer-text-muted)]">
            © 2026 인디피아. All rights reserved.
            <br />
            <span className="text-caption text-[var(--lp-footer-text-faint)]">
              Powered by Y&amp;C SmartApps Inc.
            </span>
          </p>
          <p className="mt-2 text-caption leading-relaxed text-[var(--lp-footer-text-faint)]">
            (주)와이앤씨스마트앱스 &nbsp;|&nbsp; 대표자 : 윤석중 &nbsp;|&nbsp; 서울특별시 강남구 봉은사로20길 41 와이앤씨빌딩
            <br />
            사업자등록번호 : 144-81-05037 &nbsp;|&nbsp; 통신판매업신고 : 제 2026-서울강남-00722호
            <br />
            개인정보보호책임자 : 이향호 (leehh@yncsmart.com) &nbsp;|&nbsp; 고객센터 : 1588-9592
            <br />
            호스팅 서비스 제공자 : 누리호스팅
          </p>
        </div>
      </footer>
    </div>
  );
}
